(() => {
  if (window.Shopify?.country !== 'US' || window.Shopify?.locale !== 'en') return;
  const roots = '.moonbundle-box, #moonbundle-cart-drawer';
  const labels = new Map([
    ['OFFRE SPÉCIALE', 'SPECIAL OFFER'], ['SONDERANGEBOT', 'SPECIAL OFFER'],
    ['DUO-BUNDLE: SPAREN SIE MEHR', '2-PAIR BUNDLE: SAVE MORE'],
    ['Einzelkauf', 'Single purchase'], ['Einnzelpreis', 'Single purchase'], ['Einzelpreis', 'Single purchase'],
    ['LIMITIERTES ANGEBOT', 'LIMITED OFFER'], ['Das Komplett-Paket', 'The complete bundle'],
    ['2 Hosen + taktischer Gürtel gratis. Exklusiv & limitiert', '2 pairs of pants + a free tactical belt. Exclusive, limited offer.'],
    ['🎁 Gratis-Gürtel ab 2 Hosen', '🎁 Free belt with 2 pairs'], ['Gratis-Gürtel ab 2 Hosen', 'Free belt with 2 pairs'],
    ['🎁 Free belt with 2 pants', '🎁 Free belt with 2 pairs'],
    ['STRYKR Gürtel', 'STRYKR™ Belt'], ['Gratisprodukt', 'Free gift'],
    ['Votre panier', 'Your cart'], ['Sous-total', 'Subtotal'],
    ['Votre panier est vide', 'Your cart is empty'], ['Panier vide', 'Your cart is empty'],
    ['Continuer mes achats', 'Continue shopping'], ['Continuer vos achats', 'Continue shopping'],
    ['Continuer les achats', 'Continue shopping'], ['Passer la commande', 'Checkout'],
    ['Passer au paiement', 'Checkout'], ['Commander', 'Checkout'], ['Paiement sécurisé', 'Secure checkout'],
    ['Vous économisez', 'You save'], ['Économies', 'Savings'], ['Livraison gratuite', 'Free shipping'],
    ['Livraison', 'Shipping'], ['Gratuit', 'Free'], ['Gratuite', 'Free'],
    ['Code de réduction', 'Discount code'], ['Appliquer', 'Apply'],
    ['Ajouter', 'Add'], ['Supprimer', 'Remove'], ['Fermer', 'Close'],
    ['Votre panier expire dans', 'Your cart expires in'],
    ['Votre panier expire dans :', 'Your cart expires in:'],
    ['Très bon choix !', 'Great choice!'], ['Très bon choix!', 'Great choice!'],
    ['Vous aimerez aussi', 'You may also like'],
    ['Vous avez économisé', 'You saved'], ['Produit offert', 'Free gift'],
    ['CADEAU OFFERT', 'FREE GIFT'], ['CADEAU GRATUIT', 'FREE GIFT'],
    ['En rupture de stock', 'Out of stock'], ['Quantité', 'Quantity']
  ]);
  const translate = value => {
    const key = value.trim();
    let result = labels.get(key);
    if (result === undefined) {
      result = key.replace(/^Votre panier expire dans\s*:?\s*(\d{1,2}:\d{2})$/, 'Your cart expires in $1')
        .replace(/^(\d+)x STRYKR Hosen? Straße$/, (_, n) => `${n} ${n === '1' ? 'pair' : 'pairs'} of STRYKR Street pants`)
        .replace(/^(\d+)x STRYKR Hosen? Pro$/, (_, n) => `${n} ${n === '1' ? 'pair' : 'pairs'} of STRYKR Pro Pants`)
        .replace(/^(\d+)x STRYKR Pro Pants$/, (_, n) => `${n} ${n === '1' ? 'pair' : 'pairs'} of STRYKR Pro Pants`)
        .replace(/^(\d+)x STRYKR (?:Gürtel|Belt)$/, (_, n) => `${n} STRYKR ${n === '1' ? 'Belt' : 'Belts'}`)
        .replace(/^(\d+)x Hosen?$/, (_, n) => `${n} ${n === '1' ? 'pair' : 'pairs'} of pants`)
        .replace(/^(?:Sie sparen|Vous économisez|Vous avez économisé) ([$€£\d][\d.,\s$€£]*)$/, 'You save $1');
    }
    return result === key ? value : value.slice(0, value.length - value.trimStart().length) + result + value.slice(value.trimEnd().length);
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  });
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll(roots).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.parentElement?.closest('script,style,textarea,input') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        let next = translate(node.nodeValue);
        if (node.parentElement.closest('.moonbundle-locked-text-wrapper') && /^(Nicht verfügbar|Unavailable)$/.test(node.nodeValue.trim())) next = 'With the 2-pair bundle';
        if (next !== node.nodeValue) node.nodeValue = next;
      });
      root.querySelectorAll('[aria-label],[placeholder],[title]').forEach(element => {
        ['aria-label', 'placeholder', 'title'].forEach(attribute => {
          const old = element.getAttribute(attribute);
          if (old !== null) { const next = translate(old); if (next !== old) element.setAttribute(attribute, next); }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
